<template>
  <div id="app">
    <headMenuVue></headMenuVue>
    <router-view />
    <footerVue></footerVue>
  </div>
</template>

<script>
import headMenuVue from './views/headMenu.vue'
import footerVue from './views/footer.vue'

export default {
  name: 'App',
  components: {
    headMenuVue,
    footerVue
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
</style>
